import { createProjectsBackgroundRegistry } from '../../../data/projects/hooks/projectsBackgroundRegistry';
import { getWorkHostPort } from '../../work-home/work-home-ports';

// One registry for the app. The poke is read when a subscriber emits, not at load.
const registry = createProjectsBackgroundRegistry({
  emitProjectAgentRegistryPoke: () =>
    getWorkHostPort('desktop').emitProjectAgentRegistryPoke(),
  listenProjectAgentRegistryPoke: (callback) =>
    getWorkHostPort('desktop').listenProjectAgentRegistryPoke(callback),
});

export const registerProjectBackground = registry.registerProjectBackground;
export const unregisterProjectBackground = registry.unregisterProjectBackground;
export const subscribeProjectBackground = registry.subscribeProjectBackground;
export const getProjectBackgroundSnapshot = registry.getProjectBackgroundSnapshot;
export const __resetProjectsBackgroundRegistryForTests =
  registry.__resetProjectsBackgroundRegistryForTests;
